// extracted by mini-css-extract-plugin
module.exports = {"trigger":"index_trigger__9scnB"};